import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'percentagePipe' })
export class PercentagePipe implements PipeTransform {
    transform(value: number, numDecimals: number = 0, bPercentageSign: boolean = true, bRound: boolean = false): any {
        let percentage;
        let parsedValue;
        if (bRound) {
            parsedValue = Math.round((value * 10000) / 100);
            if (parsedValue === -0) {
                parsedValue = 0;
            }
            percentage = parsedValue + ((bPercentageSign) ? '%' : '');
        } else {
            parsedValue = (value * 10000) / 100;
            if (parsedValue < 0 && parsedValue > -0.005) {
                parsedValue = 0;
            }
            percentage = parsedValue.toFixed(numDecimals) + ((bPercentageSign) ? '%' : '');
        }
        return percentage;
    }
}
